export enum PalletBoxStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export interface PalletBox {
  id: string;
  externalId: string;
  name: string;
  shipmentCount: number;
  status: PalletBoxStatus;
  createdAt: string;
  createdBy: string;
  truckId?: string;
  chuteId?: string;
}
